module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-bar"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "1px solid #eee",
      "height": "25px",
      "padding-top": "4px"
    }
  }, [_c('div', {
    staticClass: "container flex"
  }, [_c('div', [_c('img', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "alt": "定位icon",
      "src": require("../assets/icon_location.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getRegion.name))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "header-user-block"
    }
  }, [(_vm.isLogin) ? _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("购物车")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/order"
    }
  }, [_vm._v("订单")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/person"
    }
  }, [_vm._v("个人中心")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register',
        query: {
          state: '1'
        }
      }
    }
  }, [_vm._v("注册")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/login',
        query: {
          state: '1'
        }
      }
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/login',
        query: {
          state: '2'
        }
      }
    }
  }, [_vm._v("短信登录")])], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "login_hl"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "44px",
      "margin-top": "10px",
      "cursor": "pointer"
    },
    attrs: {
      "src": "//official.cdn.qiyewan.com/logo.png",
      "alt": "企业湾logo",
      "title": "企业湾"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("公司信息")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5a229806!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/TopBarTiny.vue
// module id = 1041
// module chunks = 40